<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  .doc-input(tab-index="1", href="javascript:;")
    template(v-if="isEmpty")
      a.link(v-if="isEdit", @click="addFolder") #[i.el-icon-plus/] 添加文档
      span.gap(v-else) 暂无文件
    template(v-else)
      a.link(@click="previewFn") 文档详情({{ idList.length }})
      a.link.gap(v-if="isEdit", @click="addFolder") #[i.el-icon-edit/]
      a.link.del-btn(v-if="isEdit", @click="deleteFile(folderList)")
        i.el-icon-delete
</template>
<script>
import { formInputMixins, staticMixins } from "@/CommonDP/VForm/utils";
import { openDoc } from "@/CommonDP/components/custom-dialog/index.js";
import FileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
import approveService from "@/CommonDP/service/approve-service";
import docService from "@/CommonDP/service/doc-service";
import { set } from "lodash-es";
import { getServerFiles, pathSeparator, separator } from "./utils";

export default {
  components: { FileIcon },
  mixins: [staticMixins, formInputMixins],
  computed: {
    fileLabel() {
      const { idList } = this;
      return idList?.length ? `文档详情(${idList.length})` : "暂无文件";
    },
    idList() {
      if (!this.fieldModel) return [];
      return this.fieldModel.split(separator);
    },
    flowId() {
      return this.getFlowDetail?.()?.detail?.flowInstanceId;
    },
    showDelBtn() {
      return this.isEdit && this.fieldModel;
    },
    isEmpty() {
      return !this.fieldModel;
    }
  },
  methods: {
    openDoc,
    getServerFiles,
    async previewFn() {
      const {
        fieldModel,
        idList,
        flowId,
        subFormName,
        parentWidget,
        options: { name }
      } = this;
      if (!fieldModel) return this.throwErr("暂未关联任何文档");
      const to = { name: "flow-file" };
      if (flowId) {
        const path = [flowId];
        if (subFormName) {
          const sublist = parentWidget.options.sublist;
          path.push(subFormName, this.bind.subFormColIndex);
          const sortName = name.match(new RegExp(sublist + "_\\d+-(.+)$"))?.[1] || name;
          path.push(sortName);
        } else {
          path.push(name);
        }
        set(to, "query.path", path.join("."));
      } else {
        const list = await getServerFiles(idList);
        const blob = new Blob([JSON.stringify(list)]);
        const url = URL.createObjectURL(blob);
        const preId = url.slice(-36);
        set(to, "query.preId", preId);
      }
      const { href } = this.$router.resolve(to);
      window.open(href);
    },
    async deleteFile() {
      await this.$confirm("确定清空所有数据?", "警告");
      this.fieldModel = "";
      this.$emit("delete");
    },
    async addFolder() {
      if (!this.isEdit) return;
      const {
        prjId,
        idList,
        options: { prjRoot }
      } = this;
      let prjRootId = prjRoot;
      if (prjRoot) {
        const { data } = await approveService.queryByOldld(prjRoot, prjId);
        prjRootId = data;
      }
      const folderList = await getServerFiles(idList);
      const defaultList = folderList.map((f) => {
        const idPath = f.absolutFolderPathId.split(pathSeparator);
        const namePath = f.absolutFolderPathName.split(pathSeparator);
        if (prjRootId) {
          const index = idPath.indexOf(prjRootId);
          idPath.splice(0, index + 1);
          namePath.splice(0, index + 1);
        }
        return { ...f, fullName: namePath.join("/"), fullIdPath: idPath.join("/") };
      });
      const list = await this.openDoc({
        prjId,
        defaultList,
        rootPath: "项目",
        // 所有文件都可选
        check: () => true,
        // 自定义勾选逻辑
        customCheck(node) {
          const {
            data: { isFolder }
          } = node;
          if (!isFolder) return;
          const checked = this.idList;
          const checkedSet = new Set(checked);
          const childFiles = node.childNodes.filter((f) => !f.data.isFolder);
          const childIds = childFiles.map(({ key }) => key);
          const allIn = childIds.every((id) => checkedSet.has(id));
          for (const fNode of childFiles) {
            if (allIn) this.delFolder(fNode.data);
            else this.addFolder(fNode);
          }
          return false; // 拒绝默认逻辑
        },
        filter: (Vo) => Vo.folderId !== "recycle",
        async queryRoot() {
          const params = {
            folderId: prjRootId || "0",
            isRead: 1,
            priviAll: "1",
            prjId: this.prjId
          };
          const { data } = await docService.queryTree(params);
          return data.map(item => {
            const { childFolder = 0 } = item;
            return {
              ...item,
              leaf: childFolder === 0
            };
          });
        }
      });
      this.fieldModel = list.map(({ folderId }) => folderId).join(separator);
      this.emitValidate();
    }
  }
};
</script>
<style lang="scss" scoped>
.doc-input {
  display: flex;
  flex-flow: row nowrap;
  font-size: 14px;
  .del-btn {
    color: #d60a0a;
  }
  span {
    font-size: 1em;
  }
}

.folder-name {
  display: flex;
  flex-flow: row nowrap;
  gap: 4px;
  .folder-icon {
    flex-shrink: 0;
  }
  .file-name-label {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.gap {
  margin-inline: var(--middle-space);
}
a.link {
  $link-color: #4777e7;
  color: $link-color;
  font-size: 1em;
  cursor: pointer;
  user-select: none;
  &:hover,
  &:link {
    opacity: 0.8;
  }
}
</style>
